import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Container from "@mui/material/Container";
import IconButton from "@mui/material/IconButton";
import InputLabel from "@mui/material/InputLabel";
import Link from "@mui/material/Link";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import GitHubIcon from "@mui/icons-material/GitHub";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import TwitterIcon from "@mui/icons-material/X";
import SitemarkIcon from "./SitemarkIcon";

function Copyright() {
  return (
    <Typography variant="body2" sx={{ color: "text.secondary", mt: 1 }}>
      {"Copyright © "}
      <Link color="text.secondary" href="https://mui.com/">
        Oks technologies
      </Link>
      &nbsp;
      {new Date().getFullYear()}
    </Typography>
  );
}

export default function Footer() {
  const scrollToSection = (id: string) => {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    }
  };
  return (
    <Container
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: { xs: 4, sm: 8 },
        py: { xs: 2, sm: 5 },
        mt: { xs: 2, sm: 5 },
        textAlign: { sm: "center", md: "left" },
        borderTop: "1px solid",
        borderColor: "divider",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          width: "100%",
          justifyContent: "space-between",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 4,
            minWidth: { xs: "100%", sm: "60%", cursor: "pointer" },
          }}
          onClick={() => scrollToSection("hero")}
        >
          <Box sx={{ width: { xs: "100%", sm: "60%" } }}>
            <SitemarkIcon />
          </Box>
        </Box>
        <Box sx={{ display: { xs: "none", md: "flex" } }}>
          <Button
            variant="text"
            color="info"
            size="small"
            onClick={() => scrollToSection("hero")}
          >
            Bosh sahifa
          </Button>
          <Button
            variant="text"
            color="info"
            size="small"
            onClick={() => scrollToSection("highlights")}
          >
            Loyiha haqida
          </Button>
          <Button
            variant="text"
            color="info"
            size="small"
            onClick={() => scrollToSection("testimonials")}
          >
            A'zolar
          </Button>

          <Button
            variant="text"
            color="info"
            size="small"
            onClick={() => scrollToSection("articles")}
          >
            Ilmiy maqolalar
          </Button>
          {/* <Button variant="text" color="info" size="small" sx={{ minWidth: 0 }}>
            Bo'glanish
          </Button> */}
        </Box>
      </Box>
    </Container>
  );
}
